import { render, staticRenderFns } from "./skucalc.vue?vue&type=template&id=6bdfeae6&scoped=true"
import script from "./skucalc.vue?vue&type=script&lang=js"
export * from "./skucalc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdfeae6",
  null
  
)

export default component.exports